import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UserManagementComponent} from './user-management.component';
import {SystemRolesListComponent} from './system-roles-list/system-roles-list.component';
import {ngxPermissionsGuard} from "ngx-permissions";
import {UserManagementDashboardComponent} from "./user-management-dashboard/user-management-dashboard.component";
import {UsersListComponent} from "./users-list/users-list.component";

export const routes: Routes = [
  {
    path: '',
    component: UserManagementComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: UserManagementDashboardComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          menu: {title: 'Dashboard', iconType: 'MAT', icon: 'dashboard'},
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        }
      },
      {
        path: 'system-user-roles-list',
        component: SystemRolesListComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          menu: {title: 'Roles', iconType: 'MAT', icon: 'groups'},
          isGlobal: false,
          permissions: {
            only: ['can_view_role'],
            redirectTo: ['not-allowed']
          },
        }
      },
      {
        path: 'user-list',
        component: UsersListComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          menu: {title: 'Users', iconType: 'MAT', icon: 'account_circle'},
          permissions: {
            only: ['can_view_user'],
            redirectTo: ['not-allowed']
          },
        }
      },
    

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule {
}
